var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from "react";
import { inject, observer } from "mobx-react";
import { HeaderBusiness } from "@business/common/header";
import { AccountBusiness } from "@business/account/login";
import MenuLink from "./menuLink";
import MenuProfile from "./menuProfile";
import MenuPortalHowTo from "./menuPortalHowTo";
import { withRouter } from "react-router-dom";
import { AmplitudeEventName, AmplitudeProjectName, PredefinedClient, SourceType, SourceTypeName } from "@common/enums/base";
import { combine } from "fe-toolkit";
import $http, { sendAmplitude } from "@http";
import { AbFeatures, hasAbFeature } from "@common/utils/abFeature";
import { redirectToLoginPage, isDAR } from "@common/utils";
import { sendAmplitudeLogEvent } from "one-amplitude";
import Cookies from "js-cookie";
var Menu = /** @class */ (function (_super) {
    __extends(Menu, _super);
    function Menu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            loading: false,
        };
        _this.onSignOut = function () { return __awaiter(_this, void 0, void 0, function () {
            var isUserSSOEnabled, clientId, userId, url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ loading: true });
                        return [4 /*yield*/, this.isSSOEnabled()];
                    case 1:
                        isUserSSOEnabled = _a.sent();
                        if (!isUserSSOEnabled) return [3 /*break*/, 2];
                        this.signOutForOauthSSOUser();
                        return [3 /*break*/, 4];
                    case 2:
                        clientId = Cookies.get("clientId");
                        userId = Cookies.get("userId");
                        sendAmplitudeLogEvent(AmplitudeEventName.New_logout_click, {
                            customerId: clientId || "",
                            userId: userId || "",
                            sourcetypeid: SourceType.Rsp,
                            sourcetypename: SourceTypeName.Rsp
                        }, AmplitudeProjectName.NewLogin);
                        url = "/DRSP/Account/SignOut";
                        return [4 /*yield*/, $http.post(url)];
                    case 3:
                        data = _a.sent();
                        this.setState({ loading: false });
                        redirectToLoginPage();
                        sendAmplitude(this.props.currentUser, AmplitudeEventName.Panel_SignOut);
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.isSSOEnabled = function () { return __awaiter(_this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/DRSP/Account/IsClientUserOauthSingleSignOn";
                        return [4 /*yield*/, $http.get(url)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data.data];
                }
            });
        }); };
        _this.signOutForOauthSSOUser = function () { return __awaiter(_this, void 0, void 0, function () {
            var clientId, userId, url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clientId = Cookies.get("clientId");
                        userId = Cookies.get("userId");
                        sendAmplitudeLogEvent(AmplitudeEventName.New_logout_click, {
                            userId: userId || "",
                            customerId: clientId || "",
                            sourcetypeid: SourceType.Rsp,
                            sourcetypename: SourceTypeName.Rsp
                        }, AmplitudeProjectName.NewLogin);
                        url = "/DRSP/Account/SignOutAfterOauthSingleSignOn";
                        return [4 /*yield*/, $http.post(url)];
                    case 1:
                        data = _a.sent();
                        this.setState({ loading: false });
                        sendAmplitude(this.props.currentUser, AmplitudeEventName.Panel_SignOut);
                        // @ts-ignore
                        window.location.href = "" + data.data;
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    Menu.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var homeElement, scheduleElement, serviceElement, ratingElement, messageElement, contactElement, settingElement, trainingElement, signOutElement;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        homeElement = document.getElementById("homeOption");
                        homeElement && (homeElement.style.display = 'none');
                        scheduleElement = document.getElementById("scheduleOption");
                        scheduleElement && (scheduleElement.style.display = 'none');
                        serviceElement = document.getElementById("serviceOption");
                        serviceElement && (serviceElement.style.display = 'none');
                        ratingElement = document.getElementById("ratingOption");
                        ratingElement && (ratingElement.style.display = 'none');
                        messageElement = document.getElementById("messagesOption");
                        messageElement && (messageElement.style.display = 'none');
                        contactElement = document.getElementById("contactOption");
                        contactElement && (contactElement.style.display = 'none');
                        settingElement = document.getElementById("settingsOption");
                        settingElement && (settingElement.style.display = 'none');
                        trainingElement = document.getElementById("trainingOption");
                        trainingElement && (trainingElement.style.display = 'none');
                        signOutElement = document.getElementById("signOutOption");
                        signOutElement && (signOutElement.style.display = 'none');
                        return [4 /*yield*/, this.props.getCustomConfigs()
                                .then(function () {
                                var customConfigs = _this.props.customConfigs;
                                var idsToFind = ["homeOption", "scheduleOption", "serviceOption", "ratingOption", "messagesOption", "contactOption", "settingsOption", "trainingOption", "signOutOption"];
                                var results = customConfigs.reduce(function (acc, item) {
                                    if (idsToFind.includes(item.Id)) {
                                        acc[item.Id] = item.Visible;
                                    }
                                    else {
                                        acc[item.Id] = true;
                                    }
                                    return acc;
                                }, {});
                                results["homeOption"] && homeElement && (homeElement.style.display = 'block');
                                results["scheduleOption"] && scheduleElement && (scheduleElement.style.display = 'block');
                                results["serviceOption"] && serviceElement && (serviceElement.style.display = 'block');
                                results["ratingOption"] && ratingElement && (ratingElement.style.display = 'block');
                                results["messagesOption"] && messageElement && (messageElement.style.display = 'block');
                                results["contactOption"] && contactElement && (contactElement.style.display = 'block');
                                results["settingsOption"] && settingElement && (settingElement.style.display = 'block');
                                results["trainingOption"] && trainingElement && (trainingElement.style.display = 'block');
                                results["signOutOption"] && signOutElement && (signOutElement.style.display = 'block');
                            }).catch(function (error) {
                                homeElement && (homeElement.style.display = 'block');
                                scheduleElement && (scheduleElement.style.display = 'block');
                                serviceElement && (serviceElement.style.display = 'block');
                                ratingElement && (ratingElement.style.display = 'block');
                                messageElement && (messageElement.style.display = 'block');
                                contactElement && (contactElement.style.display = 'block');
                                settingElement && (settingElement.style.display = 'block');
                                trainingElement && (trainingElement.style.display = 'block');
                                signOutElement && (signOutElement.style.display = 'block');
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Menu.prototype.renderIhMenu = function () {
        var _this = this;
        var isNotSandBoxAbFeature = !hasAbFeature(AbFeatures.Sandbox);
        return (React.createElement(React.Fragment, null,
            isNotSandBoxAbFeature && (React.createElement(MenuLink, { to: "/maintenanceHowTo", label: "Maintenance How To", iconClass: "icon-default", onClick: function () { return _this.menuClickObserver(AmplitudeEventName.Panel_MaintenanceHowTo); } })),
            React.createElement(MenuPortalHowTo, { title: "Portal How To", clickVideos: function () { return _this.menuClickObserver(AmplitudeEventName.Panel_PortalHowTo_Videos); }, clickGuides: function () { return _this.menuClickObserver(AmplitudeEventName.Panel_PortalHowTo_Guides); } }),
            React.createElement(MenuLink, { id: "contactOption", to: "/contactUs", label: "Contact Us", iconClass: "icon-contact", onClick: function () { return _this.menuClickObserver(AmplitudeEventName.Panel_ContactUs); } }),
            !isDAR() && React.createElement(MenuLink, { id: "settingsOption", to: "/settings", label: "Settings", iconClass: "icon-settings", onClick: function () { return _this.menuClickObserver(AmplitudeEventName.Panel_Settings); } })));
    };
    Menu.prototype.renderNoIhMenu = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement(MenuLink, { id: "contactOption", to: "/contactUs", label: "Contact Us", iconClass: "icon-contact", onClick: function () { return _this.menuClickObserver(AmplitudeEventName.Panel_ContactUs); } }),
            !isDAR() && React.createElement(MenuLink, { id: "settingsOption", to: "/settings", label: "Settings", iconClass: "icon-settings", onClick: function () { return _this.menuClickObserver(AmplitudeEventName.Panel_Settings); } }),
            React.createElement(MenuPortalHowTo, { id: "trainingOption", title: "Training Resources", clickVideos: function () { return _this.menuClickObserver(AmplitudeEventName.Panel_TrainingResources_Videos); }, clickGuides: function () { return _this.menuClickObserver(AmplitudeEventName.Panel_TrainingResources_Guides); } })));
    };
    Menu.prototype.menuClickObserver = function (menuName) {
        sendAmplitude(this.props.currentUser, menuName);
    };
    Menu.prototype.render = function () {
        var _this = this;
        var _a = this.props, menuShow = _a.menuShow, clientId = _a.clientId;
        var isWphOrIH = [PredefinedClient.WPH, PredefinedClient.IH].indexOf(Number(clientId)) > -1;
        return (React.createElement("nav", { className: "sidebar", id: "navbar", style: { display: menuShow ? "block" : "none" } },
            React.createElement("ul", { className: "nav" },
                React.createElement(MenuProfile, null),
                !isDAR() && React.createElement(MenuLink, { id: "homeOption", to: "/", label: "Home", iconClass: "icon-home", onClick: function () { return _this.menuClickObserver(AmplitudeEventName.Panel_Home); } }),
                React.createElement(MenuLink, { id: "scheduleOption", to: "/scheduledService", label: "Scheduled Service", iconClass: "icon-scheduled", onClick: function () { return _this.menuClickObserver(AmplitudeEventName.Panel_ScheduledService); } }),
                React.createElement(MenuLink, { id: "serviceOption", to: "/serviceHistory", label: "Service History", iconClass: "icon-history", onClick: function () { return _this.menuClickObserver(AmplitudeEventName.Panel_ServiceHistory); } }),
                !isWphOrIH ? React.createElement(MenuLink, { id: "ratingOption", to: "/serviceRating", label: "Service Rating", iconClass: "icon-rating", onClick: function () { return _this.menuClickObserver(AmplitudeEventName.Panel_ServiceRating); } }) : null,
                React.createElement(MenuLink, { id: "messagesOption", to: "/messages", label: "Messages", iconClass: "icon-messages", onClick: function () { return _this.menuClickObserver(AmplitudeEventName.Panel_Messages); } }),
                isWphOrIH ? this.renderIhMenu() : this.renderNoIhMenu(),
                !isDAR() && React.createElement("li", { id: "signOutOption", onClick: this.onSignOut, className: "nav-item" },
                    React.createElement("a", { href: "javascript:void 0;", className: "nav-link" },
                        React.createElement("i", { className: "iconfont icon-sign-out" }),
                        "Sign Out")))));
    };
    Menu = __decorate([
        inject(combine(AccountBusiness, HeaderBusiness)),
        observer
    ], Menu);
    return Menu;
}(React.Component));
export default withRouter(Menu);
